var chunkToChildrenMap = {
	"9025": [
		1659,
		18,
		4777,
		3352,
		4980,
		6760,
		8532,
		6685,
		7967
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));